import { GiftCardStatus } from '../enums/gift-card.enum';

export class GiftCarFromNonce {
  constructor(
    public merchant_id: string = null,
    public nonce: string = null
  ) {
  }
}

export class GiftCard {
  constructor(
    public balance: number = 0,
    public state: GiftCardStatus = null,
  ) {
  }
}

export class CustomerGiftCard {
  constructor(
    public balance_money:{amount:number,currency:string} = {amount:0,currency:'USD'},
    public gan:string=null,
    public type:string=null
  ){}

}

export class PartialBalance {
  constructor(
    public giftCard: number = 0,
    public card: number = 0,
  ) {
  }
}
